import classnames from 'classnames';
import React, { FC, memo, useEffect, useRef, useState } from 'react';

import { CitySuggestion } from 'Components/LocationSelect/LocationSearch.helpers';
import WizardLocation from 'Components/WizardLocation/WizardLocation';
import platformDetector from 'common/helpers/platformDetector';

import './WizardLocationSticky.scss';

type Props = {
  city?: CitySuggestion;
  neighbourhood?: {
    id: string;
    name: string;
    slug: string;
  };
};

const mobileOffset = 55;
const desktopOffset = 68;

const WizardLocationSticky: FC<Props> = (props) => {
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const [initialPosition, setInitialPosition] = useState<number>(0);
  const elementRef = useRef<HTMLDivElement | null>(null);

  const isMobile = platformDetector.isAnyMobile();

  const checkInitialPosition = (): void => {
    if (!elementRef.current) {
      return;
    }

    let position: number = elementRef.current.getBoundingClientRect().top + window.pageYOffset;
    const navigation = document.getElementById('navigation');

    if (platformDetector.isAnyMobile() && navigation) {
      position -= navigation.getBoundingClientRect().height;
    }

    setInitialPosition(position);
  };

  const getSearchOffset = () => (isMobile ? mobileOffset : desktopOffset);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stickLocation = (): void => {
    const { pageYOffset } = window;

    if (pageYOffset >= initialPosition - getSearchOffset() && !isSticky) {
      setIsSticky(true);
    } else if (pageYOffset < initialPosition - getSearchOffset() && isSticky) {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    checkInitialPosition();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', stickLocation);
    return () => window.removeEventListener('scroll', stickLocation);
  }, [stickLocation]);

  const CN = classnames('wizardLocationSticky__sticker', {
    wizardLocationSticky__sticker_fixed: isSticky,
  });

  return (
    <div className="wizardLocationSticky" ref={elementRef}>
      <div className={CN}>
        {isSticky && <p className="wizardLocationSticky__title">Gdzie usługa ma być wykonana?</p>}
        <div className="wizardLocationSticky__wrap">
          <WizardLocation city={props.city} neighbourhood={props.neighbourhood} />
        </div>
      </div>
    </div>
  );
};

export default memo(WizardLocationSticky);
